define('C3.Utils.CartUtils', [], function() {
    'use strict';

    function isItemInCart(application, itemId, optionsToCheck) {
        var cart = application.getComponent('Cart');
        return cart.getLines().then(function (lines) {
            var existingLine = _.find(lines, function(line) {
                if (String(line.item.internalid) !== String(itemId)) return false;

                return _.every(optionsToCheck, function(val, key) {
                    var opt = _.findWhere(line.options, { cartOptionId: key });
                    return opt && opt.value.internalid === val;
                });
            });

            return !!existingLine;
        });
    }

    function removeItemFromCart(application, itemId, optionsToCheck) {
    var cart = application.getComponent('Cart');

    return cart.getLines().then(function (lines) {
        var line = _.find(lines, function (l) {
            if (String(l.item.internalid) !== String(itemId)) return false;

            return _.every(optionsToCheck || {}, function (val, key) {
                var opt = _.findWhere(l.options, { cartOptionId: key });
                return opt && String(opt.value.internalid) === String(val);
            });
        });

        if (line) {
            return cart.removeLine({ line_id: line.internalid })
                .then(function (res) {
                   // console.log('Removed:', res);
                    return true;
                })
                .catch(function (err) {
                   // console.error('Remove failed:', err);
                    return false;
                });
        }

        return false;
    });
}





    function batchCheckItemsInCart(application, itemId, inventoryRecords) {
        // console.log(inventoryRecords)
        var cart = application.getComponent('Cart');
        return cart.getLines().then(function (lines) {
            var itemLines = _.filter(lines, function(line) {
                return String(line.item.internalid) === String(itemId);
            });
           // console.log(itemLines)
            /*return _.map(inventoryRecords, function(record) {
                var inCart = _.some(itemLines, function(line) {
                    var opt = _.findWhere(line.options, { cartOptionId: 'custcol_internalassettag' });
                    return opt && opt.value.internalid === record.assettag;
                });
                return _.extend({}, record, { inCart: inCart });
            });*/

            return {
                inventoryRecords: _.map(inventoryRecords, function(record) {
                    var inCart = _.some(itemLines, function(line) {
                        var opt = _.findWhere(line.options, {
                            cartOptionId: 'custcol_internalassettag'
                        });

                        return opt && opt.value.internalid === record.assettag;
                    });

                    return _.extend({}, record, {
                        inCart: inCart
                    });
                }),

                cartAssets: _.chain(itemLines)
                    .map(function(line) {
                        var opt = _.findWhere(line.options, {
                            cartOptionId: 'custcol_internalassettag'
                        });

                        return opt && opt.value.internalid;
                    })
                    .compact()
                    .value()
            };
        });
    }

    return {
        isItemInCart: isItemInCart,
        removeItemFromCart: removeItemFromCart,
        batchCheckItemsInCart: batchCheckItemsInCart
    };
});
